import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Shield, HardDrive, Users, Activity, AlertTriangle, Download, FileText, CheckSquare, Database, Lock, CheckCircle2, FileSearch, ShieldAlert, Cpu, Network, Zap, FileWarning, RefreshCw, BrainCircuit } from 'lucide-react';
type TabType = 'audit' | 'users' | 'governance' | 'health' | 'ai' | 'answers';
// Mock Data
const AUDIT_LOGS = [{
  id: 1,
  timestamp: 'Today 10:42 AM',
  user: 'Sarah Jenkins',
  matter: 'Ramirez v. Lone Star',
  action: 'Corpus Search',
  detail: "Searched: 'evidence of driver fatigue'",
  type: 'Search',
  risk: false
}, {
  id: 2,
  timestamp: 'Today 10:15 AM',
  user: 'AI Engine',
  matter: 'Ramirez v. Lone Star',
  action: 'Draft Generated',
  detail: 'Interrogatories re: hours of service (15 items)',
  type: 'Draft Generation',
  risk: true
}, {
  id: 3,
  timestamp: 'Today 09:30 AM',
  user: 'System',
  matter: 'Ramirez v. Lone Star',
  action: 'Workflow Completed',
  detail: 'Medical Chronology generation (10 entries extracted)',
  type: 'Workflow',
  risk: false
}, {
  id: 4,
  timestamp: 'Today 09:00 AM',
  user: 'Sarah Jenkins',
  matter: 'Ramirez v. Lone Star',
  action: 'Low-Confidence Approval',
  detail: 'Approved ELD log classification at 72% confidence',
  type: 'Approval',
  risk: true
}, {
  id: 5,
  timestamp: 'Yesterday 04:15 PM',
  user: 'David Chen',
  matter: 'Castillo Premises',
  action: 'Document Reclassified',
  detail: "Changed 'Site_Photos.zip' from Evidence to Correspondence",
  type: 'Classification',
  risk: false
}, {
  id: 6,
  timestamp: 'Yesterday 02:00 PM',
  user: 'Sarah Jenkins',
  matter: 'Ramirez v. Lone Star',
  action: 'Chronology Exported',
  detail: 'Exported medical chronology to XLSX (10 entries)',
  type: 'Export',
  risk: false
}, {
  id: 7,
  timestamp: 'Yesterday 11:30 AM',
  user: 'Jessica Pearson',
  matter: 'Medina Medical Neg.',
  action: 'Citation Opened',
  detail: 'Viewed Dr. Smith Deposition p.42, Bates RLSF-0345',
  type: 'Document Access',
  risk: false
}, {
  id: 8,
  timestamp: 'Mar 01, 03:45 PM',
  user: 'System',
  matter: 'Ramirez v. Lone Star',
  action: 'Bates Workflow Executed',
  detail: 'Stamped 441 pages (RLSF-0001 to RLSF-0441)',
  type: 'Workflow',
  risk: false
}, {
  id: 9,
  timestamp: 'Mar 01, 11:20 AM',
  user: 'Jessica Pearson',
  matter: 'Ramirez v. Lone Star',
  action: 'Document Upload',
  detail: 'Uploaded Demand Letter Draft — v3.docx',
  type: 'Document Access',
  risk: false
}, {
  id: 10,
  timestamp: 'Feb 20, 03:45 PM',
  user: 'AI Engine',
  matter: 'Ramirez v. Lone Star',
  action: 'Auto-Classification',
  detail: "Classified Expert Report — Dr. Allen as 'Expert Report' (100%)",
  type: 'Classification',
  risk: false
}, {
  id: 11,
  timestamp: 'Feb 15, 10:00 AM',
  user: 'System',
  matter: 'Global',
  action: 'Backup Completed',
  detail: 'Full system backup (412 GB) to encrypted local storage',
  type: 'System',
  risk: false
}, {
  id: 12,
  timestamp: 'Feb 05, 09:15 AM',
  user: 'Michael Ross',
  matter: 'Johnson Auto Collision',
  action: 'Document Excluded',
  detail: 'Excluded duplicate police report from corpus',
  type: 'Classification',
  risk: false
}, {
  id: 13,
  timestamp: 'Jan 25, 01:15 PM',
  user: 'AI Engine',
  matter: 'Ramirez v. Lone Star',
  action: 'Entity Extraction',
  detail: 'Extracted 42 entities from Dr. Smith Deposition',
  type: 'Workflow',
  risk: false
}, {
  id: 14,
  timestamp: 'Jan 18, 09:00 AM',
  user: 'Sarah Jenkins',
  matter: 'Ramirez v. Lone Star',
  action: 'Approval',
  detail: 'Approved medical chronology (87% avg confidence)',
  type: 'Approval',
  risk: false
}, {
  id: 15,
  timestamp: 'Jan 10, 02:30 PM',
  user: 'David Chen',
  matter: 'Ortega Industrial',
  action: 'OCR Quality Alert',
  detail: 'Flagged 3 documents with OCR quality below 70%',
  type: 'System',
  risk: true
}];
const USERS = [{
  id: 1,
  name: 'Sarah Jenkins',
  role: 'Managing Partner',
  email: 's.jenkins@festerygalaw.com',
  status: 'Active',
  lastLogin: 'Today, 10:42 AM',
  matters: 'All Matters'
}, {
  id: 2,
  name: 'David Chen',
  role: 'Associate',
  email: 'd.chen@festerygalaw.com',
  status: 'Active',
  lastLogin: 'Yesterday, 04:15 PM',
  matters: '4 Matters'
}, {
  id: 3,
  name: 'Jessica Pearson',
  role: 'Senior Associate',
  email: 'j.pearson@festerygalaw.com',
  status: 'Active',
  lastLogin: 'Mar 01, 11:20 AM',
  matters: 'All Matters'
}, {
  id: 4,
  name: 'Michael Ross',
  role: 'Associate',
  email: 'm.ross@festerygalaw.com',
  status: 'Active',
  lastLogin: 'Feb 05, 09:15 AM',
  matters: '2 Matters'
}, {
  id: 5,
  name: 'Ana Torres',
  role: 'Paralegal',
  email: 'a.torres@festerygalaw.com',
  status: 'Active',
  lastLogin: 'Today, 08:00 AM',
  matters: '3 Matters'
}, {
  id: 6,
  name: 'Robert Kim',
  role: 'IT Administrator',
  email: 'r.kim@festerygalaw.com',
  status: 'Active',
  lastLogin: 'Today, 07:30 AM',
  matters: 'System Only'
}];
const MATTER_ACCESS = [{
  matter: 'Ramirez v. Lone Star Freight',
  level: 'Full',
  users: 5,
  lastAccess: 'Today, 10:42 AM'
}, {
  matter: 'Castillo Premises Liability',
  level: 'Full',
  users: 3,
  lastAccess: 'Yesterday, 04:15 PM'
}, {
  matter: 'Ortega Industrial Injury',
  level: 'Restricted',
  users: 2,
  lastAccess: 'Jan 10, 02:30 PM'
}, {
  matter: 'Johnson Auto Collision',
  level: 'Full',
  users: 4,
  lastAccess: 'Feb 05, 09:15 AM'
}, {
  matter: 'Medina Medical Negligence',
  level: 'Restricted',
  users: 2,
  lastAccess: 'Yesterday, 11:30 AM'
}];
const INGESTION_SOURCES = [{
  source: 'Dropbox',
  status: 'Connected',
  lastSync: 'Today, 08:00 AM',
  docs: '847',
  errors: 0,
  health: 'Healthy'
}, {
  source: 'iCloud',
  status: 'Connected',
  lastSync: 'Today, 07:45 AM',
  docs: '312',
  errors: 0,
  health: 'Healthy'
}, {
  source: 'Local Upload',
  status: 'Active',
  lastSync: 'Today, 10:42 AM',
  docs: '1,204',
  errors: 0,
  health: 'Healthy'
}, {
  source: 'Email Ingestion',
  status: 'Connected',
  lastSync: 'Yesterday, 11:00 PM',
  docs: '423',
  errors: 2,
  health: 'Warning'
}, {
  source: 'SharePoint',
  status: 'Disconnected',
  lastSync: 'Never',
  docs: '0',
  errors: '-',
  health: 'Offline'
}];
const ANSWER_RUNS = [{
  id: 'ar-1',
  timestamp: 'Today, 10:42 AM',
  user: 'Sarah Jenkins',
  matter: 'Ramirez v. Lone Star Freight',
  query: 'What treatment did Ramirez receive after the October 2023 collision?',
  confidence: 94,
  citations: 4,
  status: 'Sourced',
  duration: '2.1s'
}, {
  id: 'ar-2',
  timestamp: 'Today, 09:15 AM',
  user: 'David Chen',
  matter: 'Castillo Premises Liability',
  query: 'What was the exact speed of the truck at impact?',
  confidence: 45,
  citations: 2,
  status: 'Insufficient Evidence',
  duration: '3.4s'
}, {
  id: 'ar-3',
  timestamp: 'Yesterday, 04:30 PM',
  user: 'Jessica Pearson',
  matter: 'Ortega Industrial Injury',
  query: 'Summarize the safety protocols mentioned in the employee handbook.',
  confidence: 88,
  citations: 3,
  status: 'Sourced',
  duration: '1.8s'
}, {
  id: 'ar-4',
  timestamp: 'Yesterday, 02:10 PM',
  user: 'Michael Ross',
  matter: 'Johnson Auto Collision',
  query: 'List all prior back injuries reported by the plaintiff.',
  confidence: 92,
  citations: 5,
  status: 'Sourced',
  duration: '2.5s'
}, {
  id: 'ar-5',
  timestamp: 'Yesterday, 11:05 AM',
  user: 'Sarah Jenkins',
  matter: 'Medina Medical Negligence',
  query: 'Did Dr. Smith consult with any specialists before surgery?',
  confidence: 78,
  citations: 1,
  status: 'Low Confidence',
  duration: '2.9s'
}, {
  id: 'ar-6',
  timestamp: 'Mar 02, 03:45 PM',
  user: 'Ana Torres',
  matter: 'Ramirez v. Lone Star Freight',
  query: 'Find mentions of driver fatigue in the ELD logs.',
  confidence: 96,
  citations: 2,
  status: 'Sourced',
  duration: '1.5s'
}, {
  id: 'ar-7',
  timestamp: 'Mar 02, 01:20 PM',
  user: 'David Chen',
  matter: 'Castillo Premises Liability',
  query: 'When was the last maintenance performed on the elevator?',
  confidence: 35,
  citations: 0,
  status: 'Insufficient Evidence',
  duration: '4.1s'
}, {
  id: 'ar-8',
  timestamp: 'Mar 01, 10:30 AM',
  user: 'Jessica Pearson',
  matter: 'Ortega Industrial Injury',
  query: 'What were the weather conditions on the day of the incident?',
  confidence: 85,
  citations: 2,
  status: 'Sourced',
  duration: '1.9s'
}];
export function Admin() {
  const [activeTab, setActiveTab] = useState<TabType>('audit');
  // Filter states (visual only for prototype)
  const [dateFilter, setDateFilter] = useState('All Time');
  const [userFilter, setUserFilter] = useState('All Users');
  const [matterFilter, setMatterFilter] = useState('All Matters');
  const [eventTypeFilter, setEventTypeFilter] = useState('All Events');
  const [riskFilter, setRiskFilter] = useState('All');
  const getEventTypeBadgeVariant = (type: string): 'secondary' | 'default' | 'outline' | 'warning' | 'success' => {
    switch (type) {
      case 'Search':
        return 'secondary';
      case 'Draft Generation':
        return 'default';
      case 'Workflow':
        return 'outline';
      case 'Classification':
        return 'warning';
      case 'Document Access':
        return 'secondary';
      case 'Approval':
        return 'success';
      case 'Export':
        return 'outline';
      case 'System':
        return 'secondary';
      default:
        return 'default';
    }
  };
  const getRoleBadgeVariant = (role: string): 'default' | 'secondary' | 'outline' | 'warning' => {
    switch (role) {
      case 'Managing Partner':
        return 'default';
      case 'Associate':
        return 'secondary';
      case 'Senior Associate':
        return 'secondary';
      case 'Paralegal':
        return 'outline';
      case 'IT Administrator':
        return 'warning';
      default:
        return 'default';
    }
  };
  const renderTabNavigation = () => {
    const tabs: {
      id: TabType;
      label: string;
      icon: React.ElementType;
    }[] = [{
      id: 'audit',
      label: 'Audit Log',
      icon: FileSearch
    }, {
      id: 'answers',
      label: 'Answer Runs',
      icon: BrainCircuit
    }, {
      id: 'users',
      label: 'Users & Access',
      icon: Users
    }, {
      id: 'governance',
      label: 'Governance & Policies',
      icon: Shield
    }, {
      id: 'health',
      label: 'System Health',
      icon: Activity
    }, {
      id: 'ai',
      label: 'AI & Model Settings',
      icon: Cpu
    }];
    return <div className="flex space-x-1 border-b overflow-x-auto pb-px mb-6 hide-scrollbar" data-id="element-121">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center space-x-2 px-4 py-2.5 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${isActive ? 'border-blue-600 text-blue-600 dark:text-blue-400 dark:border-blue-400' : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'}`} data-id="element-122">

              <Icon className="w-4 h-4" data-id="element-123" />
              <span data-id="element-124">{tab.label}</span>
            </button>;
      })}
      </div>;
  };
  const renderAuditTab = () => <div className="space-y-4 animate-in fade-in duration-300" data-id="element-125">
      <div className="flex flex-wrap gap-3 mb-4" data-id="element-126">
        <select className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring" value={dateFilter} onChange={e => setDateFilter(e.target.value)} data-id="element-127">

          <option data-id="element-128">All Time</option>
          <option data-id="element-129">Today</option>
          <option data-id="element-130">Last 7 Days</option>
          <option data-id="element-131">Last 30 Days</option>
          <option data-id="element-132">Last 90 Days</option>
        </select>
        <select className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring" value={userFilter} onChange={e => setUserFilter(e.target.value)} data-id="element-133">

          <option data-id="element-134">All Users</option>
          <option data-id="element-135">Sarah Jenkins</option>
          <option data-id="element-136">David Chen</option>
          <option data-id="element-137">Jessica Pearson</option>
          <option data-id="element-138">Michael Ross</option>
          <option data-id="element-139">System</option>
          <option data-id="element-140">AI Engine</option>
        </select>
        <select className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring max-w-[200px] truncate" value={matterFilter} onChange={e => setMatterFilter(e.target.value)} data-id="element-141">

          <option data-id="element-142">All Matters</option>
          <option data-id="element-143">Ramirez v. Lone Star Freight</option>
          <option data-id="element-144">Castillo Premises Liability</option>
          <option data-id="element-145">Ortega Industrial Injury</option>
          <option data-id="element-146">Johnson Auto Collision</option>
          <option data-id="element-147">Medina Medical Negligence</option>
        </select>
        <select className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring" value={eventTypeFilter} onChange={e => setEventTypeFilter(e.target.value)} data-id="element-148">

          <option data-id="element-149">All Events</option>
          <option data-id="element-150">Search</option>
          <option data-id="element-151">Export</option>
          <option data-id="element-152">Workflow</option>
          <option data-id="element-153">Classification</option>
          <option data-id="element-154">Draft Generation</option>
          <option data-id="element-155">Document Access</option>
          <option data-id="element-156">Approval</option>
          <option data-id="element-157">System</option>
        </select>
        <select className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring" value={riskFilter} onChange={e => setRiskFilter(e.target.value)} data-id="element-158">

          <option data-id="element-159">All Risk Levels</option>
          <option data-id="element-160">Flagged Only</option>
          <option data-id="element-161">No Flags</option>
        </select>
        <Button variant="ghost" size="sm" className="h-9" data-id="element-162">
          Clear Filters
        </Button>
      </div>

      <Card data-id="element-163">
        <div className="overflow-x-auto" data-id="element-164">
          <table className="w-full text-sm text-left" data-id="element-165">
            <thead className="text-xs text-muted-foreground uppercase bg-muted/50 border-b" data-id="element-166">
              <tr data-id="element-167">
                <th className="px-4 py-3 font-medium w-32" data-id="element-168">Timestamp</th>
                <th className="px-4 py-3 font-medium w-36" data-id="element-169">User</th>
                <th className="px-4 py-3 font-medium w-48" data-id="element-170">Matter</th>
                <th className="px-4 py-3 font-medium" data-id="element-171">Detail</th>
                <th className="px-4 py-3 font-medium" data-id="element-172">Event Type</th>
                <th className="px-4 py-3 font-medium w-12 text-center" data-id="element-173">Risk</th>
              </tr>
            </thead>
            <tbody className="divide-y" data-id="element-174">
              {AUDIT_LOGS.map(log => <tr key={log.id} className={`hover:bg-muted/30 ${log.risk ? 'border-l-2 border-l-amber-500 bg-amber-50/10 dark:bg-amber-950/5' : 'border-l-2 border-l-transparent'}`} data-id="element-175">

                  <td className="px-4 py-3 text-muted-foreground whitespace-nowrap" data-id="element-176">
                    {log.timestamp}
                  </td>
                  <td className="px-4 py-3 font-medium" data-id="element-177">{log.user}</td>
                  <td className="px-4 py-3 text-muted-foreground truncate max-w-[150px]" data-id="element-178">
                    {log.matter}
                  </td>
                  <td className="px-4 py-3 text-muted-foreground" data-id="element-179">
                    {log.detail}
                  </td>
                  <td className="px-4 py-3" data-id="element-180">
                    <Badge variant={getEventTypeBadgeVariant(log.type)} className={log.type === 'Workflow' ? 'text-blue-600 border-blue-200 bg-blue-50 dark:bg-blue-950/20 dark:border-blue-800' : ''} data-id="element-181">

                      {log.type}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-center" data-id="element-182">
                    {log.risk && <AlertTriangle className="w-4 h-4 text-amber-500 mx-auto" data-id="element-183" />}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="p-4 border-t bg-muted/20 text-xs text-muted-foreground flex justify-between items-center" data-id="element-184">
          <span data-id="element-185">Showing 15 of 1,247 entries</span>
          <div className="flex space-x-1" data-id="element-186">
            <Button variant="outline" size="sm" className="h-7 px-2" disabled data-id="element-187">
              Previous
            </Button>
            <Button variant="outline" size="sm" className="h-7 px-2" data-id="element-188">
              Next
            </Button>
          </div>
        </div>
      </Card>
    </div>;
  const renderAnswerRunsTab = () => <div className="space-y-4 animate-in fade-in duration-300" data-id="element-189">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6" data-id="element-190">
        <Card className="bg-slate-50 border-slate-200" data-id="element-191">
          <CardContent className="p-4" data-id="element-192">
            <p className="text-xs font-medium text-muted-foreground mb-1" data-id="element-193">
              Total Runs (30d)
            </p>
            <p className="text-2xl font-bold" data-id="element-194">847</p>
          </CardContent>
        </Card>
        <Card className="bg-emerald-50 border-emerald-200" data-id="element-195">
          <CardContent className="p-4" data-id="element-196">
            <p className="text-xs font-medium text-emerald-800 mb-1" data-id="element-197">
              Avg Confidence
            </p>
            <p className="text-2xl font-bold text-emerald-700" data-id="element-198">87%</p>
          </CardContent>
        </Card>
        <Card className="bg-amber-50 border-amber-200" data-id="element-199">
          <CardContent className="p-4" data-id="element-200">
            <p className="text-xs font-medium text-amber-800 mb-1" data-id="element-201">
              Insufficient Evidence Rate
            </p>
            <p className="text-2xl font-bold text-amber-700" data-id="element-202">8%</p>
          </CardContent>
        </Card>
        <Card className="bg-blue-50 border-blue-200" data-id="element-203">
          <CardContent className="p-4" data-id="element-204">
            <p className="text-xs font-medium text-blue-800 mb-1" data-id="element-205">
              Avg Response Time
            </p>
            <p className="text-2xl font-bold text-blue-700" data-id="element-206">2.3s</p>
          </CardContent>
        </Card>
      </div>

      <div className="flex flex-wrap gap-3 mb-4" data-id="element-207">
        <select className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring" data-id="element-208">
          <option data-id="element-209">All Time</option>
          <option data-id="element-210">Today</option>
          <option data-id="element-211">Last 7 Days</option>
          <option data-id="element-212">Last 30 Days</option>
        </select>
        <select className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring" data-id="element-213">
          <option data-id="element-214">All Users</option>
          <option data-id="element-215">Sarah Jenkins</option>
          <option data-id="element-216">David Chen</option>
          <option data-id="element-217">Jessica Pearson</option>
        </select>
        <select className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring max-w-[200px] truncate" data-id="element-218">
          <option data-id="element-219">All Matters</option>
          <option data-id="element-220">Ramirez v. Lone Star Freight</option>
          <option data-id="element-221">Castillo Premises Liability</option>
          <option data-id="element-222">Ortega Industrial Injury</option>
        </select>
        <select className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring" data-id="element-223">
          <option data-id="element-224">All Confidence Levels</option>
          <option data-id="element-225">High (&gt;85%)</option>
          <option data-id="element-226">Medium (60-85%)</option>
          <option data-id="element-227">Low (&lt;60%)</option>
        </select>
        <Button variant="ghost" size="sm" className="h-9" data-id="element-228">
          Clear Filters
        </Button>
      </div>

      <Card data-id="element-229">
        <div className="overflow-x-auto" data-id="element-230">
          <table className="w-full text-sm text-left" data-id="element-231">
            <thead className="text-xs text-muted-foreground uppercase bg-muted/50 border-b" data-id="element-232">
              <tr data-id="element-233">
                <th className="px-4 py-3 font-medium w-32" data-id="element-234">Timestamp</th>
                <th className="px-4 py-3 font-medium w-36" data-id="element-235">User</th>
                <th className="px-4 py-3 font-medium w-48" data-id="element-236">Matter</th>
                <th className="px-4 py-3 font-medium" data-id="element-237">Query</th>
                <th className="px-4 py-3 font-medium w-24 text-center" data-id="element-238">
                  Conf.
                </th>
                <th className="px-4 py-3 font-medium w-24 text-center" data-id="element-239">
                  Citations
                </th>
                <th className="px-4 py-3 font-medium w-32" data-id="element-240">Status</th>
                <th className="px-4 py-3 font-medium w-24 text-right" data-id="element-241">
                  Duration
                </th>
              </tr>
            </thead>
            <tbody className="divide-y" data-id="element-242">
              {ANSWER_RUNS.map(run => <tr key={run.id} className="hover:bg-muted/30" data-id="element-243">
                  <td className="px-4 py-3 text-muted-foreground whitespace-nowrap" data-id="element-244">
                    {run.timestamp}
                  </td>
                  <td className="px-4 py-3 font-medium" data-id="element-245">{run.user}</td>
                  <td className="px-4 py-3 text-muted-foreground truncate max-w-[150px]" data-id="element-246">
                    {run.matter}
                  </td>
                  <td className="px-4 py-3 text-slate-700 truncate max-w-[250px]" title={run.query} data-id="element-247">

                    {run.query}
                  </td>
                  <td className="px-4 py-3 text-center" data-id="element-248">
                    <Badge variant={run.confidence > 85 ? 'success' : run.confidence > 60 ? 'warning' : 'destructive'} className="text-[10px]" data-id="element-249">

                      {run.confidence}%
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-center font-medium" data-id="element-250">
                    {run.citations}
                  </td>
                  <td className="px-4 py-3" data-id="element-251">
                    <Badge variant={run.status === 'Sourced' ? 'outline' : run.status === 'Insufficient Evidence' ? 'destructive' : 'warning'} className="font-normal bg-background" data-id="element-252">

                      {run.status}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-right text-muted-foreground" data-id="element-253">
                    {run.duration}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="p-4 border-t bg-muted/20 text-xs text-muted-foreground flex justify-between items-center" data-id="element-254">
          <span data-id="element-255">Showing 8 of 847 entries</span>
          <div className="flex space-x-1" data-id="element-256">
            <Button variant="outline" size="sm" className="h-7 px-2" disabled data-id="element-257">
              Previous
            </Button>
            <Button variant="outline" size="sm" className="h-7 px-2" data-id="element-258">
              Next
            </Button>
          </div>
        </div>
      </Card>
    </div>;
  const renderUsersTab = () => <div className="space-y-6 animate-in fade-in duration-300" data-id="element-259">
      <Card data-id="element-260">
        <CardHeader className="pb-3 flex flex-row items-center justify-between" data-id="element-261">
          <div data-id="element-262">
            <CardTitle className="text-lg" data-id="element-263">User Management</CardTitle>
            <CardDescription data-id="element-264">
              Manage firm personnel and their platform access.
            </CardDescription>
          </div>
          <div className="flex space-x-2" data-id="element-265">
            <Button variant="outline" size="sm" data-id="element-266">
              Export User Report
            </Button>
            <Button size="sm" data-id="element-267">Invite User</Button>
          </div>
        </CardHeader>
        <div className="overflow-x-auto" data-id="element-268">
          <table className="w-full text-sm text-left border-t" data-id="element-269">
            <thead className="text-xs text-muted-foreground uppercase bg-muted/50 border-b" data-id="element-270">
              <tr data-id="element-271">
                <th className="px-4 py-3 font-medium" data-id="element-272">User</th>
                <th className="px-4 py-3 font-medium" data-id="element-273">Role</th>
                <th className="px-4 py-3 font-medium" data-id="element-274">Email</th>
                <th className="px-4 py-3 font-medium" data-id="element-275">Status</th>
                <th className="px-4 py-3 font-medium" data-id="element-276">Last Login</th>
                <th className="px-4 py-3 font-medium" data-id="element-277">Matters Accessible</th>
                <th className="px-4 py-3 font-medium text-right" data-id="element-278">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y" data-id="element-279">
              {USERS.map(user => <tr key={user.id} className="hover:bg-muted/30" data-id="element-280">
                  <td className="px-4 py-3 font-medium" data-id="element-281">{user.name}</td>
                  <td className="px-4 py-3" data-id="element-282">
                    <Badge variant={getRoleBadgeVariant(user.role)} className="font-normal" data-id="element-283">

                      {user.role}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-muted-foreground" data-id="element-284">
                    {user.email}
                  </td>
                  <td className="px-4 py-3" data-id="element-285">
                    <span className="inline-flex items-center text-xs font-medium text-emerald-600 dark:text-emerald-400" data-id="element-286">
                      <span className="w-2 h-2 rounded-full bg-emerald-500 mr-1.5" data-id="element-287"></span>
                      {user.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-muted-foreground" data-id="element-288">
                    {user.lastLogin}
                  </td>
                  <td className="px-4 py-3 text-muted-foreground" data-id="element-289">
                    {user.matters}
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-290">
                    <Button variant="ghost" size="sm" className="h-7 px-2 text-blue-600" data-id="element-291">

                      Edit
                    </Button>
                    <Button variant="ghost" size="sm" className="h-7 px-2 text-destructive" data-id="element-292">

                      Revoke
                    </Button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <Card data-id="element-293">
        <CardHeader className="pb-3" data-id="element-294">
          <CardTitle className="text-lg" data-id="element-295">Matter Access Control</CardTitle>
          <CardDescription data-id="element-296">
            Granular access permissions by matter.
          </CardDescription>
        </CardHeader>
        <div className="overflow-x-auto" data-id="element-297">
          <table className="w-full text-sm text-left border-t" data-id="element-298">
            <thead className="text-xs text-muted-foreground uppercase bg-muted/50 border-b" data-id="element-299">
              <tr data-id="element-300">
                <th className="px-4 py-3 font-medium" data-id="element-301">Matter</th>
                <th className="px-4 py-3 font-medium" data-id="element-302">Access Level</th>
                <th className="px-4 py-3 font-medium" data-id="element-303">Users with Access</th>
                <th className="px-4 py-3 font-medium" data-id="element-304">Last Access</th>
                <th className="px-4 py-3 font-medium text-right" data-id="element-305">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y" data-id="element-306">
              {MATTER_ACCESS.map((ma, i) => <tr key={i} className="hover:bg-muted/30" data-id="element-307">
                  <td className="px-4 py-3 font-medium" data-id="element-308">{ma.matter}</td>
                  <td className="px-4 py-3" data-id="element-309">
                    <Badge variant={ma.level === 'Full' ? 'outline' : 'warning'} className="font-normal bg-background" data-id="element-310">

                      {ma.level}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-muted-foreground" data-id="element-311">
                    {ma.users} users
                  </td>
                  <td className="px-4 py-3 text-muted-foreground" data-id="element-312">
                    {ma.lastAccess}
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-313">
                    <Button variant="outline" size="sm" className="h-7 px-3" data-id="element-314">
                      Manage Access
                    </Button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
  const renderGovernanceTab = () => <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-in fade-in duration-300" data-id="element-315">
      <Card data-id="element-316">
        <CardHeader className="pb-3" data-id="element-317">
          <CardTitle className="text-lg flex items-center" data-id="element-318">
            <CheckSquare className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-319" />
            Workflow Approval Rules
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4" data-id="element-320">
          <div className="space-y-3" data-id="element-321">
            {[{
            rule: 'Require attorney approval for all AI-generated drafts',
            active: true
          }, {
            rule: 'Require approval for chronology exports',
            active: true
          }, {
            rule: 'Auto-approve classifications above 95% confidence',
            active: true
          }, {
            rule: 'Require dual approval for privilege designations',
            active: false
          }, {
            rule: 'Notify managing partner on document exclusions',
            active: true
          }].map((item, i) => <div key={i} className="flex items-center justify-between" data-id="element-322">
                <span className={`text-sm ${item.active ? 'text-foreground' : 'text-muted-foreground'}`} data-id="element-323">

                  {item.rule}
                </span>
                <div className={`w-8 h-4 rounded-full flex items-center px-0.5 ${item.active ? 'bg-emerald-500 justify-end' : 'bg-muted justify-start'}`} data-id="element-324">

                  <div className="w-3 h-3 rounded-full bg-white shadow-sm" data-id="element-325"></div>
                </div>
              </div>)}
          </div>
          <Button variant="outline" size="sm" className="w-full mt-4" data-id="element-326">
            Edit Rules
          </Button>
        </CardContent>
      </Card>

      <Card data-id="element-327">
        <CardHeader className="pb-3" data-id="element-328">
          <CardTitle className="text-lg flex items-center" data-id="element-329">
            <Activity className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-330" />
            Confidence Threshold Settings
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-5" data-id="element-331">
          <div data-id="element-332">
            <div className="flex justify-between text-sm mb-1" data-id="element-333">
              <span className="font-medium" data-id="element-334">Auto-approve threshold</span>
              <span className="text-emerald-600 font-bold" data-id="element-335">95%</span>
            </div>
            <div className="w-full bg-muted rounded-full h-2" data-id="element-336">
              <div className="bg-emerald-500 h-2 rounded-full" style={{
              width: '95%'
            }} data-id="element-337">
            </div>
            </div>
            <p className="text-xs text-muted-foreground mt-1" data-id="element-338">
              Outputs above this score bypass the review queue.
            </p>
          </div>
          <div data-id="element-339">
            <div className="flex justify-between text-sm mb-1" data-id="element-340">
              <span className="font-medium" data-id="element-341">Review required threshold</span>
              <span className="text-amber-600 font-bold" data-id="element-342">75%</span>
            </div>
            <div className="w-full bg-muted rounded-full h-2" data-id="element-343">
              <div className="bg-amber-500 h-2 rounded-full" style={{
              width: '75%'
            }} data-id="element-344">
            </div>
            </div>
            <p className="text-xs text-muted-foreground mt-1" data-id="element-345">
              Outputs between 60-94% require standard attorney review.
            </p>
          </div>
          <div data-id="element-346">
            <div className="flex justify-between text-sm mb-1" data-id="element-347">
              <span className="font-medium" data-id="element-348">Auto-flag threshold</span>
              <span className="text-red-600 font-bold" data-id="element-349">60%</span>
            </div>
            <div className="w-full bg-muted rounded-full h-2" data-id="element-350">
              <div className="bg-red-500 h-2 rounded-full" style={{
              width: '60%'
            }} data-id="element-351">
            </div>
            </div>
            <p className="text-xs text-muted-foreground mt-1" data-id="element-352">
              Outputs below this score are flagged as high-risk.
            </p>
          </div>
          <Button variant="outline" size="sm" className="w-full mt-2" data-id="element-353">
            Adjust Thresholds
          </Button>
        </CardContent>
      </Card>

      <Card data-id="element-354">
        <CardHeader className="pb-3" data-id="element-355">
          <CardTitle className="text-lg flex items-center" data-id="element-356">
            <FileWarning className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-357" />
            Document Exclusion Policies
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4" data-id="element-358">
          <div className="space-y-3" data-id="element-359">
            {[{
            rule: 'Exclude documents marked Attorney-Client privilege from AI processing',
            active: true
          }, {
            rule: 'Exclude documents marked Work Product from corpus search',
            active: true
          }, {
            rule: 'Flag duplicate documents for manual review before exclusion',
            active: true
          }, {
            rule: 'Auto-exclude files with OCR quality below 40%',
            active: false
          }].map((item, i) => <div key={i} className="flex items-start justify-between space-x-4" data-id="element-360">

                <span className={`text-sm ${item.active ? 'text-foreground' : 'text-muted-foreground'}`} data-id="element-361">

                  {item.rule}
                </span>
                <div className={`w-8 h-4 rounded-full flex items-center px-0.5 shrink-0 mt-0.5 ${item.active ? 'bg-emerald-500 justify-end' : 'bg-muted justify-start'}`} data-id="element-362">

                  <div className="w-3 h-3 rounded-full bg-white shadow-sm" data-id="element-363"></div>
                </div>
              </div>)}
          </div>
          <Button variant="outline" size="sm" className="w-full mt-4" data-id="element-364">
            Edit Policies
          </Button>
        </CardContent>
      </Card>

      <Card data-id="element-365">
        <CardHeader className="pb-3" data-id="element-366">
          <CardTitle className="text-lg flex items-center" data-id="element-367">
            <FileSearch className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-368" />
            Duplicate Detection Rules
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4" data-id="element-369">
          <div className="space-y-2" data-id="element-370">
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-371">
              <span className="text-sm text-muted-foreground" data-id="element-372">
                Detection method
              </span>
              <span className="text-sm font-medium" data-id="element-373">
                Content hash + fuzzy title
              </span>
            </div>
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-374">
              <span className="text-sm text-muted-foreground" data-id="element-375">
                Similarity threshold
              </span>
              <span className="text-sm font-medium" data-id="element-376">85%</span>
            </div>
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-377">
              <span className="text-sm text-muted-foreground" data-id="element-378">
                Action on detection
              </span>
              <span className="text-sm font-medium" data-id="element-379">Flag for review</span>
            </div>
            <div className="flex justify-between py-1" data-id="element-380">
              <span className="text-sm text-muted-foreground" data-id="element-381">
                Duplicates found this month
              </span>
              <Badge variant="secondary" className="font-normal" data-id="element-382">
                3
              </Badge>
            </div>
          </div>
          <Button variant="outline" size="sm" className="w-full mt-2" data-id="element-383">
            Configure
          </Button>
        </CardContent>
      </Card>

      <Card data-id="element-384">
        <CardHeader className="pb-3" data-id="element-385">
          <CardTitle className="text-lg flex items-center" data-id="element-386">
            <HardDrive className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-387" />
            Retention & Backup
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4" data-id="element-388">
          <div className="space-y-2" data-id="element-389">
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-390">
              <span className="text-sm text-muted-foreground" data-id="element-391">
                Retention period
              </span>
              <span className="text-sm font-medium" data-id="element-392">
                7 years (per firm policy)
              </span>
            </div>
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-393">
              <span className="text-sm text-muted-foreground" data-id="element-394">
                Auto-backup schedule
              </span>
              <span className="text-sm font-medium" data-id="element-395">Daily at 03:00 AM</span>
            </div>
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-396">
              <span className="text-sm text-muted-foreground" data-id="element-397">Last backup</span>
              <span className="text-sm font-medium" data-id="element-398">
                Today, 03:00 AM — 412 GB
              </span>
            </div>
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-399">
              <span className="text-sm text-muted-foreground" data-id="element-400">
                Last snapshot
              </span>
              <span className="text-sm font-medium" data-id="element-401">
                Mar 01, 2024 — Full corpus
              </span>
            </div>
            <div className="flex justify-between py-1" data-id="element-402">
              <span className="text-sm text-muted-foreground" data-id="element-403">
                Backup encryption
              </span>
              <span className="text-sm font-medium text-emerald-600" data-id="element-404">
                AES-256 (Enabled)
              </span>
            </div>
          </div>
          <div className="flex space-x-2 mt-2" data-id="element-405">
            <Button variant="outline" size="sm" className="flex-1" data-id="element-406">
              View History
            </Button>
            <Button size="sm" className="flex-1" data-id="element-407">
              Run Manual Backup
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card data-id="element-408">
        <CardHeader className="pb-3" data-id="element-409">
          <CardTitle className="text-lg flex items-center" data-id="element-410">
            <ShieldAlert className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-411" />
            Review Policy Configuration
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4" data-id="element-412">
          <div className="p-3 bg-muted/50 rounded-md border border-border/50 mb-2" data-id="element-413">
            <p className="text-sm font-medium mb-1" data-id="element-414">Current Policy Summary</p>
            <p className="text-xs text-muted-foreground" data-id="element-415">
              Strict review mode is active. All generative outputs require
              human-in-the-loop verification before export or finalization.
            </p>
          </div>
          <div className="space-y-3" data-id="element-416">
            {[{
            rule: 'All AI outputs require attorney review',
            active: true
          }, {
            rule: 'Low-confidence items auto-routed to managing partner',
            active: true
          }, {
            rule: 'Review deadline: 48 hours from generation',
            active: true
          }, {
            rule: 'Escalation: Unreviewed items flagged after 72 hours',
            active: true
          }].map((item, i) => <div key={i} className="flex items-start space-x-3" data-id="element-417">
                <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" data-id="element-418" />
                <span className="text-sm text-foreground" data-id="element-419">{item.rule}</span>
              </div>)}
          </div>
        </CardContent>
      </Card>
    </div>;
  const renderHealthTab = () => <div className="space-y-6 animate-in fade-in duration-300" data-id="element-420">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-421">
        <Card data-id="element-422">
          <CardContent className="p-4" data-id="element-423">
            <div className="flex justify-between items-start mb-2" data-id="element-424">
              <span className="text-sm font-medium text-muted-foreground" data-id="element-425">
                System Status
              </span>
              <Activity className="w-4 h-4 text-muted-foreground" data-id="element-426" />
            </div>
            <div className="flex items-center space-x-2" data-id="element-427">
              <span className="w-2.5 h-2.5 rounded-full bg-emerald-500" data-id="element-428"></span>
              <span className="text-xl font-bold" data-id="element-429">Online & Secure</span>
            </div>
            <p className="text-xs text-muted-foreground mt-1" data-id="element-430">Uptime: 99.97%</p>
          </CardContent>
        </Card>
        <Card data-id="element-431">
          <CardContent className="p-4" data-id="element-432">
            <div className="flex justify-between items-start mb-2" data-id="element-433">
              <span className="text-sm font-medium text-muted-foreground" data-id="element-434">
                Storage
              </span>
              <HardDrive className="w-4 h-4 text-muted-foreground" data-id="element-435" />
            </div>
            <div className="text-xl font-bold" data-id="element-436">
              412 GB{' '}
              <span className="text-sm font-normal text-muted-foreground" data-id="element-437">
                / 2 TB
              </span>
            </div>
            <div className="w-full bg-muted rounded-full h-1.5 mt-2 mb-1" data-id="element-438">
              <div className="bg-emerald-500 h-1.5 rounded-full" style={{
              width: '20%'
            }} data-id="element-439">
            </div>
            </div>
            <p className="text-xs text-emerald-600 font-medium" data-id="element-440">Healthy</p>
          </CardContent>
        </Card>
        <Card data-id="element-441">
          <CardContent className="p-4" data-id="element-442">
            <div className="flex justify-between items-start mb-2" data-id="element-443">
              <span className="text-sm font-medium text-muted-foreground" data-id="element-444">
                Documents Indexed
              </span>
              <Database className="w-4 h-4 text-muted-foreground" data-id="element-445" />
            </div>
            <div className="text-xl font-bold" data-id="element-446">14,205</div>
            <p className="text-xs text-muted-foreground mt-1" data-id="element-447">+47 this week</p>
          </CardContent>
        </Card>
        <Card data-id="element-448">
          <CardContent className="p-4" data-id="element-449">
            <div className="flex justify-between items-start mb-2" data-id="element-450">
              <span className="text-sm font-medium text-muted-foreground" data-id="element-451">
                Active Connections
              </span>
              <Network className="w-4 h-4 text-muted-foreground" data-id="element-452" />
            </div>
            <div className="text-xl font-bold" data-id="element-453">4</div>
            <p className="text-xs text-muted-foreground mt-1" data-id="element-454">users online</p>
          </CardContent>
        </Card>
      </div>

      <Card data-id="element-455">
        <CardHeader className="pb-3 flex flex-row items-center justify-between" data-id="element-456">
          <CardTitle className="text-lg flex items-center" data-id="element-457">
            <RefreshCw className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-458" />
            Ingestion Source Health
          </CardTitle>
          <Button variant="outline" size="sm" data-id="element-459">
            Sync All Now
          </Button>
        </CardHeader>
        <div className="overflow-x-auto" data-id="element-460">
          <table className="w-full text-sm text-left border-t" data-id="element-461">
            <thead className="text-xs text-muted-foreground uppercase bg-muted/50 border-b" data-id="element-462">
              <tr data-id="element-463">
                <th className="px-4 py-3 font-medium" data-id="element-464">Source</th>
                <th className="px-4 py-3 font-medium" data-id="element-465">Status</th>
                <th className="px-4 py-3 font-medium" data-id="element-466">Last Sync</th>
                <th className="px-4 py-3 font-medium" data-id="element-467">Documents Synced</th>
                <th className="px-4 py-3 font-medium" data-id="element-468">Errors</th>
                <th className="px-4 py-3 font-medium" data-id="element-469">Health</th>
              </tr>
            </thead>
            <tbody className="divide-y" data-id="element-470">
              {INGESTION_SOURCES.map((source, i) => <tr key={i} className="hover:bg-muted/30" data-id="element-471">
                  <td className="px-4 py-3 font-medium" data-id="element-472">{source.source}</td>
                  <td className="px-4 py-3" data-id="element-473">
                    <Badge variant={source.status === 'Connected' || source.status === 'Active' ? 'success' : 'destructive'} className="font-normal" data-id="element-474">

                      {source.status}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-muted-foreground" data-id="element-475">
                    {source.lastSync}
                  </td>
                  <td className="px-4 py-3 font-medium" data-id="element-476">{source.docs}</td>
                  <td className="px-4 py-3 text-muted-foreground" data-id="element-477">
                    {source.errors}
                  </td>
                  <td className="px-4 py-3" data-id="element-478">
                    <span className="inline-flex items-center text-xs font-medium" data-id="element-479">
                      <span className={`w-2 h-2 rounded-full mr-1.5 ${source.health === 'Healthy' ? 'bg-emerald-500' : source.health === 'Warning' ? 'bg-amber-500' : 'bg-red-500'}`} data-id="element-480">
                  </span>
                      {source.health}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-481">
        <Card data-id="element-482">
          <CardHeader className="pb-3" data-id="element-483">
            <CardTitle className="text-lg flex items-center" data-id="element-484">
              <FileSearch className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-485" />
              OCR Quality Monitoring
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4" data-id="element-486">
            <div data-id="element-487">
              <div className="flex justify-between text-sm mb-1" data-id="element-488">
                <span className="font-medium" data-id="element-489">Overall Quality Score</span>
                <span className="font-bold text-emerald-600" data-id="element-490">91.2%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2" data-id="element-491">
                <div className="bg-emerald-500 h-2 rounded-full" style={{
                width: '91.2%'
              }} data-id="element-492">
              </div>
              </div>
            </div>

            <div className="pt-2" data-id="element-493">
              <p className="text-sm font-medium mb-3" data-id="element-494">Documents by Quality</p>
              <div className="space-y-2" data-id="element-495">
                {[{
                label: 'Excellent',
                count: 412,
                color: 'bg-emerald-500',
                width: '70%'
              }, {
                label: 'Good',
                count: 287,
                color: 'bg-blue-500',
                width: '45%'
              }, {
                label: 'Fair',
                count: 48,
                color: 'bg-amber-500',
                width: '15%'
              }, {
                label: 'Poor',
                count: 12,
                color: 'bg-red-500',
                width: '5%'
              }].map((item, i) => <div key={i} className="flex items-center text-sm" data-id="element-496">
                    <span className="w-20 text-muted-foreground" data-id="element-497">
                      {item.label}
                    </span>
                    <div className="flex-1 mx-3 h-1.5 bg-muted rounded-full overflow-hidden" data-id="element-498">
                      <div className={`h-full ${item.color} rounded-full`} style={{
                    width: item.width
                  }} data-id="element-499" />

                    </div>
                    <span className="w-8 text-right font-medium" data-id="element-500">
                      {item.count}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="mt-4 p-3 bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-900/50 rounded-md" data-id="element-501">
              <p className="text-xs text-amber-800 dark:text-amber-300 font-medium flex items-center mb-1" data-id="element-502">
                <AlertTriangle className="w-3.5 h-3.5 mr-1.5" data-id="element-503" />3 documents
                flagged for re-processing
              </p>
              <p className="text-xs text-amber-700/80 dark:text-amber-400/80 ml-5" data-id="element-504">
                Poor quality documents require manual review.
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-505">
          <CardHeader className="pb-3" data-id="element-506">
            <CardTitle className="text-lg flex items-center" data-id="element-507">
              <Lock className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-508" />
              E2E Encryption & Security
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4" data-id="element-509">
            <div className="space-y-3" data-id="element-510">
              <div className="flex justify-between items-center py-1 border-b border-border/50" data-id="element-511">
                <span className="text-sm text-muted-foreground" data-id="element-512">
                  Encryption
                </span>
                <span className="text-sm font-medium text-emerald-600" data-id="element-513">
                  AES-256 — Enabled
                </span>
              </div>
              <div className="flex justify-between items-center py-1 border-b border-border/50" data-id="element-514">
                <span className="text-sm text-muted-foreground" data-id="element-515">
                  TLS Version
                </span>
                <span className="text-sm font-medium" data-id="element-516">1.3 — Active</span>
              </div>
              <div className="flex justify-between items-center py-1 border-b border-border/50" data-id="element-517">
                <span className="text-sm text-muted-foreground" data-id="element-518">
                  External API Access
                </span>
                <Badge variant="destructive" className="font-normal" data-id="element-519">
                  Disabled (Air-gapped)
                </Badge>
              </div>
              <div className="flex justify-between items-center py-1 border-b border-border/50" data-id="element-520">
                <span className="text-sm text-muted-foreground" data-id="element-521">
                  Last Security Scan
                </span>
                <span className="text-sm font-medium" data-id="element-522">Today, 03:00 AM</span>
              </div>
              <div className="flex justify-between items-center py-1" data-id="element-523">
                <span className="text-sm text-muted-foreground" data-id="element-524">
                  Vulnerabilities Found
                </span>
                <span className="text-sm font-medium text-emerald-600" data-id="element-525">0</span>
              </div>
            </div>
            <Button variant="outline" size="sm" className="w-full mt-2" data-id="element-526">
              View Security Report
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>;
  const renderAITab = () => <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-in fade-in duration-300" data-id="element-527">
      <Card data-id="element-528">
        <CardHeader className="pb-3" data-id="element-529">
          <CardTitle className="text-lg flex items-center" data-id="element-530">
            <Cpu className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-531" />
            Model Configuration
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4" data-id="element-532">
          <div className="space-y-2" data-id="element-533">
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-534">
              <span className="text-sm text-muted-foreground" data-id="element-535">
                Active Model
              </span>
              <span className="text-sm font-medium" data-id="element-536">
                Local LLM — Llama 3.1 70B (Quantized)
              </span>
            </div>
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-537">
              <span className="text-sm text-muted-foreground" data-id="element-538">
                Inference Engine
              </span>
              <span className="text-sm font-medium" data-id="element-539">
                llama.cpp on local GPU cluster
              </span>
            </div>
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-540">
              <span className="text-sm text-muted-foreground" data-id="element-541">
                Context Window
              </span>
              <span className="text-sm font-medium" data-id="element-542">128K tokens</span>
            </div>
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-543">
              <span className="text-sm text-muted-foreground" data-id="element-544">Temperature</span>
              <span className="text-sm font-medium" data-id="element-545">
                0.1 (conservative for legal work)
              </span>
            </div>
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-546">
              <span className="text-sm text-muted-foreground" data-id="element-547">
                Max Output Tokens
              </span>
              <span className="text-sm font-medium" data-id="element-548">4,096</span>
            </div>
            <div className="flex justify-between py-1" data-id="element-549">
              <span className="text-sm text-muted-foreground" data-id="element-550">Status</span>
              <Badge variant="success" className="font-normal" data-id="element-551">
                Running
              </Badge>
            </div>
          </div>
          <div className="mt-2 p-3 bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-900/50 rounded-md flex items-start" data-id="element-552">
            <Shield className="w-4 h-4 text-blue-600 dark:text-blue-400 mr-2 shrink-0 mt-0.5" data-id="element-553" />
            <p className="text-xs text-blue-800 dark:text-blue-300" data-id="element-554">
              Model is running locally. No data leaves the firm network. Fully
              compliant with client confidentiality requirements.
            </p>
          </div>
        </CardContent>
      </Card>

      <Card data-id="element-555">
        <CardHeader className="pb-3" data-id="element-556">
          <CardTitle className="text-lg flex items-center" data-id="element-557">
            <Zap className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-558" />
            Usage Statistics
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4" data-id="element-559">
          <div className="grid grid-cols-2 gap-4 mb-2" data-id="element-560">
            <div className="p-3 bg-muted/30 rounded-lg border border-border/50" data-id="element-561">
              <p className="text-xs text-muted-foreground mb-1" data-id="element-562">
                Queries this month
              </p>
              <p className="text-2xl font-bold" data-id="element-563">847</p>
            </div>
            <div className="p-3 bg-muted/30 rounded-lg border border-border/50" data-id="element-564">
              <p className="text-xs text-muted-foreground mb-1" data-id="element-565">
                Drafts generated
              </p>
              <p className="text-2xl font-bold" data-id="element-566">23</p>
            </div>
            <div className="p-3 bg-muted/30 rounded-lg border border-border/50" data-id="element-567">
              <p className="text-xs text-muted-foreground mb-1" data-id="element-568">
                Chronologies created
              </p>
              <p className="text-2xl font-bold" data-id="element-569">8</p>
            </div>
            <div className="p-3 bg-muted/30 rounded-lg border border-border/50" data-id="element-570">
              <p className="text-xs text-muted-foreground mb-1" data-id="element-571">
                Classifications performed
              </p>
              <p className="text-2xl font-bold" data-id="element-572">1,204</p>
            </div>
          </div>
          <div className="space-y-2" data-id="element-573">
            <div className="flex justify-between py-1 border-b border-border/50" data-id="element-574">
              <span className="text-sm text-muted-foreground" data-id="element-575">
                Average response time
              </span>
              <span className="text-sm font-medium" data-id="element-576">2.3 seconds</span>
            </div>
            <div className="flex justify-between py-1" data-id="element-577">
              <span className="text-sm text-muted-foreground" data-id="element-578">
                Token usage this month
              </span>
              <span className="text-sm font-medium" data-id="element-579">12.4M / unlimited</span>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card data-id="element-580">
        <CardHeader className="pb-3" data-id="element-581">
          <CardTitle className="text-lg flex items-center" data-id="element-582">
            <ShieldAlert className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-583" />
            AI Guardrails
          </CardTitle>
        </CardHeader>
        <CardContent data-id="element-584">
          <div className="space-y-3" data-id="element-585">
            {['Never generate legal advice without citation', 'Always include confidence score in outputs', 'Flag outputs below 60% confidence', 'Prohibit generation of client communications without review', 'Log all AI interactions to audit trail'].map((rule, i) => <div key={i} className="flex items-start justify-between py-1.5 border-b border-border/50 last:border-0" data-id="element-586">

                <span className="text-sm text-foreground pr-4" data-id="element-587">{rule}</span>
                <Badge variant="outline" className="text-[10px] bg-background text-emerald-600 border-emerald-200 shrink-0" data-id="element-588">

                  Enforced
                </Badge>
              </div>)}
          </div>
        </CardContent>
      </Card>

      <Card data-id="element-589">
        <CardHeader className="pb-3" data-id="element-590">
          <CardTitle className="text-lg flex items-center" data-id="element-591">
            <FileText className="w-5 h-5 mr-2 text-muted-foreground" data-id="element-592" />
            Citation Requirements
          </CardTitle>
        </CardHeader>
        <CardContent data-id="element-593">
          <div className="space-y-3" data-id="element-594">
            {['All AI answers must cite source documents', 'Minimum citations per answer: 1', 'Citation format: Bates number + document title', 'Unsupported claims flagged automatically'].map((rule, i) => <div key={i} className="flex items-start space-x-3 py-1" data-id="element-595">
                <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" data-id="element-596" />
                <span className="text-sm text-foreground" data-id="element-597">{rule}</span>
              </div>)}
          </div>
          <Button variant="outline" size="sm" className="w-full mt-4" data-id="element-598">
            Edit Citation Rules
          </Button>
        </CardContent>
      </Card>
    </div>;
  return <div className="space-y-6 max-w-7xl mx-auto pb-10" data-id="element-599">
      {/* Page Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-600">
        <div data-id="element-601">
          <h1 className="text-2xl font-bold tracking-tight" data-id="element-602">
            Administration, Governance & Audit
          </h1>
          <p className="text-muted-foreground" data-id="element-603">
            Platform security, compliance controls, and immutable activity
            records.
          </p>
        </div>
        <div className="flex space-x-2 shrink-0" data-id="element-604">
          <Button variant="outline" data-id="element-605">
            <Download className="w-4 h-4 mr-2" data-id="element-606" />
            Export Full Audit Log
          </Button>
          <Button data-id="element-607">
            <Activity className="w-4 h-4 mr-2" data-id="element-608" />
            System Health Check
          </Button>
        </div>
      </div>

      {/* Review Policy Banner */}
      <div className="bg-amber-50 border border-amber-200 dark:bg-amber-950/20 dark:border-amber-800 rounded-lg p-4 flex items-start md:items-center justify-between gap-4" data-id="element-609">
        <div className="flex items-start space-x-3" data-id="element-610">
          <Shield className="w-5 h-5 text-amber-600 dark:text-amber-500 shrink-0 mt-0.5" data-id="element-611" />
          <div data-id="element-612">
            <h3 className="text-sm font-bold text-amber-900 dark:text-amber-400" data-id="element-613">
              Review Policy Active
            </h3>
            <p className="text-sm text-amber-800 dark:text-amber-300 mt-0.5" data-id="element-614">
              All AI-generated outputs require attorney approval before use.
              Confidence threshold: 75%. Low-confidence items are auto-flagged
              for manual review.
            </p>
          </div>
        </div>
        <Button variant="outline" size="sm" className="shrink-0 bg-background/50 border-amber-200 hover:bg-amber-100 dark:border-amber-800 dark:hover:bg-amber-900" data-id="element-615">

          Edit Policy
        </Button>
      </div>

      {/* Tabs Navigation */}
      {renderTabNavigation()}

      {/* Tab Content */}
      <div className="min-h-[500px]" data-id="element-616">
        {activeTab === 'audit' && renderAuditTab()}
        {activeTab === 'answers' && renderAnswerRunsTab()}
        {activeTab === 'users' && renderUsersTab()}
        {activeTab === 'governance' && renderGovernanceTab()}
        {activeTab === 'health' && renderHealthTab()}
        {activeTab === 'ai' && renderAITab()}
      </div>
    </div>;
}